import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { internalHref } from '../utils/internalHref';

const pathNames: { [key: string]: string } = {
  'blog': 'Blog',
  'car-loan-calculator': 'Car Loan Repayment Calculator',
  'about': 'About Us',
  'privacy': 'Privacy Policy',
  'terms': 'Terms & Conditions',
  'contact': 'Contact Us'
  // Other path names...
};

const categoryPaths: { [key: string]: string } = {
  'hull-volume': 'Hull and Construction',
  'inflatable-volume': 'Hull and Construction',
  // Add category mappings for all calculators...
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6">
      <Link to="/" className="flex items-center hover:text-blue-600 transition-colors">
        <Home className="h-4 w-4" />
      </Link>
      
      <ChevronRight className="h-4 w-4 text-gray-400" />
      
      {pathSegments.map((segment, index) => {
        const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
        const isLast = index === pathSegments.length - 1;
        
        // Special case for blog posts
        const isBlogPost = pathSegments[0] === 'blog' && index === 1;
        const displayName = isBlogPost 
          ? 'Blog Post' 
          : pathNames[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
        
        return (
          <React.Fragment key={path}>
            <span
              className={isLast ? 'text-blue-600 font-medium' : ''}
            >
              {isLast || isBlogPost ? (
                displayName
              ) : (
                <Link
                  to={internalHref(path)}
                  className="hover:text-blue-600 transition-colors"
                >
                  {displayName}
                </Link>
              )}
            </span>
            {!isLast && <ChevronRight className="h-4 w-4 text-gray-400" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;